import React from "react";
import { useTheme, createUseStyles } from "react-jss";

import { SimpleCTASection, SimpleCTASectionHeader, SimpleCTASectionButton } from "components/SimpleCTASection";

const useStyles = createUseStyles({
  wrapper: {
    marginTop: '4rem'
  }
});

const Subscribe = () => {
  const theme = useTheme();
  const styles = useStyles();

  return (
    <SimpleCTASection className={styles.wrapper} background={theme.colors.gray.lightest}>
      <SimpleCTASectionHeader>Subscribe</SimpleCTASectionHeader>
      <p>Are you interested in bringing machine learning intelligence to your devices? We're happy to help.</p>
      <SimpleCTASectionButton href="/subscribe"  useLink={true}>Subscribe to our newsletter</SimpleCTASectionButton>
    </SimpleCTASection>
  )
};

export default Subscribe;